import { render } from "./OrderApprove.vue?vue&type=template&id=f35c584e&scoped=true"
import script from "./OrderApprove.vue?vue&type=script&lang=js"
export * from "./OrderApprove.vue?vue&type=script&lang=js"

import "./OrderApprove.vue?vue&type=style&index=0&id=f35c584e&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f35c584e"]])

export default __exports__